<template>
	<div class="container">
		<Header class="header" />
		<Perose></Perose>
		<div class="content ">
			<div class="leftImage">
				<img src="../assets/image/leftImageOnTheHomepage.png" alt="" />
			</div>
			<div class="rightPicture">
				<img src="../assets/image/rightImageOfHomepage.png" alt="" />
			</div>
			<RouterView></RouterView>
		</div>
		<Fotter class="footer"></Fotter>
	</div>
</template>

<script>
	import Header from '../components/header.vue'
	import Fotter from '../components/fotter.vue'
	import Perose from '../components/personal.vue'
	export default {
		components: {
			Fotter,
			Perose,
			Header
		}
	}
</script>

<style lang="scss">
	// @import url("./assets/css/common.scss");

	.leftImage {
		position: absolute;
		left: 0;
		bottom: -100px;
		width: 563px;
		height: 549px;
		z-index: -1;

		img {
			width: 563px;
			height: 549px;
		}
	}

	.rightPicture {
		position: absolute;
		right: 0;
		z-index: -1;
		bottom: 380px;
		width: 471px;
		height: 471px;

		img {
			width: 471px;
			height: 471px;
		}
	}

	body {
		padding: 0;
		margin: 0;
		background: #FFFCF6;
	}

	.container {
		display: flex;
		flex-direction: column;
		height: 100vh;

		/* Full height of the viewport */
	}

	.header {
		flex: 0 0 auto;
		/* Don't grow or shrink */
	}

	.content {
		flex: 1 0 auto;
		position: relative;
		/* Grow and shrink */
		// overflow: auto;
		/* In case content is too long */
	}

	.footer {
		flex: 0 0 auto;
		/* Don't grow or shrink */
	}
</style>